<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <!-- <template v-slot:body.prepend v-if="summary">
                            <tr class="grey lighten-4 font-weight-bold">
                                <td colspan="4" class="text-right">Tổng:</td>
                                <td class="text-right">{{ summary.TotalWeight | currency('', 2) }}</td>
                                <td class="text-right">{{ summary.TotalVolume | currency('', 4) }}</td>
                                <td class="text-right blue--text">{{ summary.TotalAmount | currency('', 0) }}</td>
                                <td class="text-right" v-if="showCost">{{ summary.TotalCost | currency('', 0) }}</td>
                                <td class="text-right green--text" v-if="showCost">{{ summary.TotalProfit | currency('', 0) }}</td>
                                <td colspan="2"></td>
                            </tr>
                        </template> -->
                        <template v-slot:item="{ item }">
                            <tr>
                                <td><code>{{ item.OrderCode }}</code></td>
                                <td>
                                    <div class="font-weight-medium">{{ item.CustomerCode }}</div>
                                    <div class="caption grey--text">{{ item.CustomerFullName }}</div>
                                </td>
                                <td>
                                    <v-chip small label>{{ item.TransportType }}</v-chip>
                                </td>
                                <td>
                                    <v-chip small :color="getStatusColor(item.Status)" dark>
                                        {{ getStatusName(item.Status) }}
                                    </v-chip>
                                </td>
                                <td class="text-right">{{ item.TotalWeight | currency('', 2) }}</td>
                                <td class="text-right">{{ item.TotalVolume | currency('', 4) }}</td>
                                <td class="text-right font-weight-bold blue--text">{{ (item.TotalAmount + (item.TotalTrustFee || 0)) | currency('', 0) }}</td>
                                <td class="text-right" v-if="showCost">{{ item.TotalCost | currency('', 0) }}</td>
                                <td class="text-right green--text" v-if="showCost">{{ item.TotalProfit | currency('', 0) }}</td>
                                <td>{{ item.CreatedDate | display_date }}</td>
                                <td class="text-center" @click.stop>
                                    <v-tooltip bottom v-if="canMarkCustomsReady(item)">
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                medium
                                                class="mr-1"
                                                color="primary"
                                                v-on="on"
                                                @click="markCustomsReady(item)"
                                            >gavel</v-icon>
                                        </template>
                                        <span>Chuyển sang Chờ thông quan</span>
                                    </v-tooltip>
                                    <v-icon medium class="mr-1" @click="openDetail(item.ID)">edit</v-icon>
                                    <v-icon medium @click="deleteItem(item.ID)" v-if="adminRole">delete</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import Filtering from "@/components/Filtering";
import createPermissionMixin from "@/mixins/permissionMixin";
import _, { values } from "lodash";

export default {
    mixins: [createPermissionMixin('cn_order')],
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "cn_order_list",
            statusList: configs.CN_ORDER_STATUS_LIST,
            headers: [
                { text: 'Mã đơn', value: "OrderCode", filterable: true, dataType: configs.DATA_TYPE["String"], quickSearch: true },
                { text: 'Khách hàng', value: "CustomerName", filterable: true, dataType: configs.DATA_TYPE["String"], quickSearch: true },
                { text: 'Vận chuyển', value: "TransportType", filterable: true, dataType: configs.DATA_TYPE["String"] },
                { text: 'Trạng thái', value: "Status", filterable: true, dataType: configs.DATA_TYPE["Enum"], values: configs.CN_ORDER_STATUS_LIST },
                { text: 'Tổng cân (KG)', value: "TotalWeight", filterable: true, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Tổng khối (M3)', value: "TotalVolume", filterable: true, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Tổng phải thu', value: "TotalAmount", filterable: true, dataType: configs.DATA_TYPE["Number"] },
                ...(this.showCostHeaders()),
                { text: 'Ngày tạo', value: "CreatedDate", filterable: true, dataType: configs.DATA_TYPE["Date"] },
                { text: 'Thao tác', value: "", align: "center", sortable: false, filterable: false }
            ],
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
        };
    },
    watch: {
        pagination: {
            handler: function () {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : [];
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.cnOrder.all.data,
            total_rows: state => state.cnOrder.all.total,
            summary: state => state.cnOrder.all.summary,
            loading: state => state.cnOrder.loading,
        }),
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        accountantRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
        },
        showCost() {
            return this.adminRole || this.accountantRole;
        }
    },
    methods: {
        showCostHeaders() {
            const rid = this.$store ? this.$store.state.authentication.user.roleid : 0;
            const show = rid == configs.ROLE_TYPE.Admin || rid == configs.ROLE_TYPE.Accountant;
            if (show) {
                return [
                    { text: 'Chi phí gốc', value: "TotalCost", filterable: false },
                    { text: 'Lợi nhuận', value: "TotalProfit", filterable: false }
                ];
            }
            return [];
        },
        getStatusColor(status) {
            const found = this.statusList.find(s => s.value === status);
            return found ? found.color : '#808080';
        },
        getStatusName(status) {
            const found = this.statusList.find(s => s.value === status);
            return found ? found.name : 'N/A';
        },
        canMarkCustomsReady(item) {
            return Number(item.Status) === configs.CN_ORDER_STATUS.CHO_KHAI_BAO;
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("cnOrder/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy;
            let sortDesc = this.pagination.sortDesc;
            this.pagination = _.cloneDeep(configs.PAGINATION);
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        openDetail(id) {
            this.$router.push({ name: 'CnOrderDetail', params: { Pid: id } });
        },
        markCustomsReady(item) {
            if (!this.canMarkCustomsReady(item)) {
                return;
            }
            if (!confirm(`Xác nhận chuyển đơn ${item.OrderCode} sang Chờ thông quan?`)) {
                return;
            }
            this.$store.dispatch('cnOrder/markCustomsReady', item.ID);
        },
        deleteItem(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        }
    },
    mounted() {
        this.$root.$on("REQUEST_CREATE_DATA", () => {
            this.$router.push({ name: 'CnOrderDetail', params: { Pid: 0 } });
        });
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("cnOrder/removeDetail", id).then(() => {
                sendSuccessNotice(this, 'Xóa thành công');
                this.filter_data();
            }).catch(error => {
                sendErrorNotice(this, 'Có lỗi xảy ra: ' + (error.message || error));
            });
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
